<template>
  <div class="register-container page-container">
    <van-nav-bar style="background-color: transparent" fixed :title="this.form.referrerCod ? '邀请注册' : '注册'" left-arrow @click-left="goableBack()" />

    <div class="register flex-column">
      <div class="flex-column register_container">
        <div class="flex-column register_container_box">
          <div class="title" :style="updateTitleStyle">
            <van-notice-bar v-if="
                this.form.referrerCod &&
                inviteOrgName &&
                inviteOrgName.length > 13
              " scrollable background="none" :text="inviteOrgName" />
            <div v-else-if="this.form.referrerCod && inviteOrgName">
              {{ inviteOrgName }}
            </div>
            <div v-if="this.form.referrerCod">{{ invitor }} 邀请您注册</div>
            <div v-else>注册信息</div>
          </div>
          <div class="form-body">
            <van-cell class="fs-10" center :border="false">
              <template #title>
                <van-field type="digit" maxlength="11" center clearable placeholder="请输入您的手机号" v-model="form.mobile" />
              </template>
            </van-cell>

            <van-cell class="mt-10 fs-14" center :border="false">
              <template #title>
                <van-field type="digit" clearable center maxlength="6" placeholder="请输入6位验证码" v-model="form.registerCode" />
              </template>

              <template #right-icon>
                <div class="pr-10">
                  <van-loading size="20px" v-if="verifycode.loading" type="spinner" />
                  <span v-else-if="verifycode.remainSeconds <= 0" @click.stop="fetchVerifyCode" required class="get-verify-registerCode">
                    获取验证码
                  </span>
                  <span v-else @click.stop="fetchVerifyCode" class="get-verify-registerCode">
                    {{ verifycode.remainSeconds }}s
                  </span>
                </div>
              </template>
            </van-cell>

            <van-button @click="onClickRegister" class="mt-10 register-btn" size="large">
              注册
            </van-button>
          </div>
        </div>
        <van-row class="agreebg pt-15" align="center">
          <van-checkbox class="fs-12" v-model="form.agreement" icon-size="18px">
            <div class="agreebg-text">
              <div class="">阅读并同意</div>
              <div @click.stop="onClickProtocol" style="color: blue">
                <span style="color: black">《</span>
                天安金交中心服务协议-个人会员版
                <span style="color: black">》</span>
              </div>
            </div>
          </van-checkbox>
        </van-row>
      </div>
    </div>
    <!-- 添加图片滑动解锁 -->
    <PhotoSlide ref="slideblock" @success="onSlideSuccess" sliderText="向右滑" :show="false" :showSlidePop.sync="showSlidePop"></PhotoSlide>
  </div>
</template>


<script>
import { Field, Cell, Row, Checkbox, Loading, Dialog, NoticeBar } from "vant"
import * as userApi from "@/api/user.js"
import PhotoSlide from "../../components/photoSlide.vue"
export default {
  name: "Register",
  components: {
    [Field.name]: Field,
    [Cell.name]: Cell,
    [Checkbox.name]: Checkbox,
    [Row.name]: Row,
    [NoticeBar.name]: NoticeBar,
    [Dialog.name]: Dialog,
    [Loading.name]: Loading,
    PhotoSlide
  },

  data() {
    return {
      showSlidePop: false, // 是否显示滑块解锁框
      inviteOrgName: null, // 邀请机构名称
      invitor: null, // 邀请人
      verifycode: {
        remainSeconds: 0,
        loading: false
      },
      form: {
        mobile: "",
        registerCode: "",
        referrerType: "",
        referrerCod: "",
        agreement: false
      }
    }
  },

  computed: {
    updateTitleStyle() {
      if (this.inviteOrgName) {
        return "padding-top: 0;"
      } else {
        return "padding-top: 20px;"
      }
    }
  },

  mounted() {
    this.form.referrerCod = this.$route.query.referrerCod
    this.form.referrerType = this.$route.query.referrerType
    this.form.mobile = this.$route.query.mobile
    if (this.form.referrerCod) {
      userApi
        .getReferrer({
          id: this.form.referrerCod,
          type: this.form.referrerType
        })
        .then((data) => {
          this.inviteOrgName = data.orgName
          this.invitor = data.name
        })
        .catch((e) => {
          this._showToast(e.msg || e.message)
        })
    }
  },

  methods: {
    onClickRegister() {
      if (this.form.mobile == null || this.form.mobile == "") {
        this._showToast("请输入手机号")
        return
      }
      if (this.form.registerCode == null || this.form.registerCode == "") {
        this._showToast("请输入验证码")
        return
      }
      if (!this.form.agreement) {
        this._showToast("请勾选同意用户协议")
        return
      }
      //请求注册
      userApi
        .register(this.form)
        .then(() => {
          this.verifycode.remainSeconds = 0
          Dialog.confirm({
            title: "注册成功",
            cancelButtonText: "再逛逛",
            confirmButtonText: "立刻登录"
          })
            .then(() => {
              this.$router.push("/login?chanlCode=TA")
            })
            .catch(() => {
              this.$router.push("/home")
            })
        })
        .catch((e) => {
          this.verifycode.remainSeconds = 0
          this._showToast(e.msg || e.message)
          if (e.code == 99999) {
            Dialog.confirm({
              title: "您已经注册过了，是否需要去登录？",
              cancelButtonText: "取消",
              confirmButtonText: "去登录"
            })
              .then(() => {
                this.$router.push("/login?chanlCode=TA")
              })
              .catch(() => { })
          }
        })
    },
    onClickProtocol() {
      this.$router.push("/agreement/reg")
    },
    //滑块验证方法
    onSlideSuccess() {
      this.showSlidePop = false
      this.onSendCode()
    },
    //请求验证码接口
    onSendCode() {
      this.verifycode.loading = true
      const r = this._generateRandomString()
      const params = { phone: this.form.mobile, sign: this._getEncryption(r), r: r }
      userApi.sendcode(params)
        .then(() => {
          this.verifycode.remainSeconds = 60
          this.verifycode.loading = false
          let id = setInterval(() => {
            this.verifycode.remainSeconds = this.verifycode.remainSeconds - 1
            if (this.verifycode.remainSeconds == 0) {
              clearInterval(id)
            }
          }, 1000)
        })
        .catch((e) => {
          this.verifycode.loading = false
          this._showToast("验证码获取失败,请检查手机号后重试")
        })
    },
    fetchVerifyCode() {
      if (
        this.form.mobile == null ||
        this.form.mobile == "" ||
        this.form.mobile.length != 11
      ) {
        this._showToast("请输入正确的手机号")
        return
      }

      if (!this.form.agreement) {
        this._showToast("请勾选同意用户协议")
        return
      }
      this.showSlidePop = true
    }
  }
}
</script>

<style lang="less" scoped>
.van-nav-bar {
  background-color: transparent;
  &::after {
    display: none;
  }
}
.register-container {
  margin: 0;
  padding: 0;
  .register {
    width: 100%;
    min-height: 100vh;
    background-image: url(../../assets/img/register/register_bg.png);
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100% 100%;

    .register_container {
      align-items: center;
      .register_container_box {
        position: absolute;
        bottom: 70px;
        width: 82%;
        text-align: center;
        background-image: url(../../assets/img/register/register_form_bg.png);
        background-position: center;
        background-repeat: no-repeat;
        background-size: 100% 100%;

        .get-verify-registerCode {
          color: red;
          padding-right: 10px;
        }
        .title {
          background-color: rgb(255, 245, 235);
          border-top-left-radius: 10px;
          border-top-right-radius: 10px;
          color: #ac5807;
          letter-spacing: 1px;
          font-weight: bold;
          font-size: 0.5rem;
          margin-top: 10px;
          margin-bottom: 5px;
          margin-left: 20px;
          margin-right: 20px;
          min-height: 55px;
          .van-notice-bar {
            padding: 0 5px;
            color: #ac5807;
            font-size: 0.5rem;
          }
        }

        .form-body {
          padding: 10px;
          .van-cell {
            padding: 0.1rem;
            border-radius: 35px;
          }
          .register-btn {
            color: white;
            background-color: #ef4f26;
            border-radius: 25px;
            border: none;
            margin-bottom: 5px;
          }
        }
      }
      .agreebg {
        position: absolute;
        bottom: 20px;
        .agreebg-text {
          display: flex;
          align-items: center;
          justify-content: space-evenly;
        }
      }

      ::v-deep .van-field__control {
        padding-left: 10px;
        font-size: 14px;
      }

      ::v-deep .van-checkbox__icon .van-icon {
        border: 2px solid white;
      }
    }
  }
}
</style>
